import React from "react";
import { Wrapper } from "./Button.styled";
import { PlusCircleOutlined, MinusCircleOutlined, UploadOutlined } from "@ant-design/icons";

export const Button = ({ title, onClick, className, AddIcon, Icon, MinusIcon, loading, htmlType, style, disabled, type }) => {
    return (
        <Wrapper className={className} onClick={onClick} htmlType={htmlType} loading={loading} style={style} disabled={disabled} type={type}>
            {AddIcon && (
                <div className="addIcon">
                    <a>
                        <PlusCircleOutlined style={{ verticalAlign: "text-top" }} />
                    </a>
                </div>
            )}
            {Icon && (
                <div className="addIcon" style={{ display: "flex" }}>
                    <a>
                        <UploadOutlined style={{ verticalAlign: "text-top" }} />
                    </a>
                </div>
            )}
            {MinusIcon && (
                <div className="minusIcon">
                    <a>
                        <MinusCircleOutlined style={{ verticalAlign: "text-top" }} />
                    </a>
                </div>
            )}
            {title}
        </Wrapper>
    );
};
